<template>
  <div class="record-audio-container">
    <!-- 只允许桌面端用语音 -->
    <button
      v-if="isPC"
      class="record-btn pc"
      @click="toggleRecord"
      :disabled="disabled"
    >
      {{ isListening ? "🔴 聆听中..." : "🎤" }}
    </button>
  </div>
</template>

<script>
export default {
  props: {
    disabled: Boolean
  },
  data() {
    return {
      isPC: false,
      isListening: false,
      recognition: null,

      isRecording: false,
      mediaRecorder: null,
      mediaStream: null,
      chunks: []
    };
  },
  mounted() {
    // 精准判断是否桌面
    const ua = navigator.userAgent.toLowerCase();
    this.isPC = !ua.match(/mobile|android|iphone|ipad|harmonyos/);

    // 桌面才初始化语音识别
    if (this.isPC) {
      try {
        const Rec = window.SpeechRecognition || window.webkitSpeechRecognition;
        this.recognition = new Rec();
        this.recognition.lang = "zh-CN";
        this.recognition.continuous = false;
        this.recognition.interimResults = false;

        this.recognition.onresult = (e) => {
          const text = e.results[0][0].transcript.trim();
          this.$emit("record-result", text);
          this.stopListening();
        };
        this.recognition.onerror = () => this.stopListening();
      } catch (e) {}
    }
  },

  methods: {
    // ========== PC 语音 ==========
    toggleRecord() {
      this.isListening ? this.stopListening() : this.startListening();
    },
    startListening() {
      try { this.recognition.start(); this.isListening = true; } catch (e) {}
    },
    stopListening() {
      try { this.recognition.stop(); } catch (e) {}
      this.isListening = false;
    },

    // ========== 手机长按录音 ==========
    async handleTouchStart(e) {
	 this.$message('an')
      e.preventDefault();
      if (this.disabled || this.isRecording) return;
	this.$message('111')
      this.chunks = [];
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          audio: { echoCancellation: true, noiseSuppression: true }
        });
        this.mediaStream = stream;
        this.isRecording = true;

        const options = { mimeType: "audio/webm" };
        this.mediaRecorder = new MediaRecorder(stream, options);

        this.mediaRecorder.ondataavailable = (ev) => {
          if (ev.data.size > 0) this.chunks.push(ev.data);
        };

        this.mediaRecorder.onstop = () => {
          this.$emit("record-result", "[语音已发送]");
          this.mediaStream.getTracks().forEach(t => t.stop());
        };

        this.mediaRecorder.start();
      } catch (err) {
        console.log("录音失败", err);
      }
    },

    async handleTouchEnd(e) {
      e.preventDefault();
      if (!this.isRecording) return;

      this.isRecording = false;
      try {
        this.mediaRecorder.stop();
      } catch (e) {}
      // 适配鸿蒙延迟收尾
      await new Promise(r => setTimeout(r, 1000));
    }
  }
};
</script>

<style scoped>
.record-btn {
  padding: 6px 12px;
  border: none;
  border-radius: 6px;
  color: #fff;
  user-select: none;
  -webkit-user-select: none;
  touch-action: manipulation;
  -webkit-touch-callout: none;
}
.pc {
  background: #2d8cf0;
}
.audio-btn {
  background: #17b978;
}
.recing {
  background: #f56c6c !important;
}
.record-btn:disabled {
  background: #ccc;
}
</style>